import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { FormattedMessage } from 'react-intl';
import Menu from '../Menu';
import RepVisitsPendingCounter from '../RepVisitsPendingCounter';
import FeatureEnabled from '../FeatureEnabled';
import { REPVISITS_RSVP_COUNTER } from '../../containers/Authorization/constants';
import { active } from './styles.css';

const isCurrentLink = (props, path) => (props.currentPathName.includes(path) ? 'true' : 'false');

const MenuList = (props) => (
  <nav aria-label="RepVisits Menu">
    <Menu className={props.className} stackable as="ul" pointing secondary size="huge" styleName="menu">
      <Menu.Item as="li" link styleName="menu-item base-panel">
        <Link
          aria-current={isCurrentLink(props, 'overview')}
          aria-label="overview"
          to="/rep-visits/overview"
          styleName="menu-link"
          activeClassName={active}
        >
          <FormattedMessage id="repvisits.menu.overview" defaultMessage="Overview" />
        </Link>
      </Menu.Item>
      <Menu.Item as="li" link styleName="menu-item">
        <Link
          aria-current={isCurrentLink(props, 'search')}
          aria-label="search and schedule"
          to="/rep-visits/search"
          styleName="menu-link"
          activeClassName={active}
        >
          <FormattedMessage id="repvisits.menu.searchAndSchedule" defaultMessage="Search and Schedule" />
        </Link>
      </Menu.Item>
      <Menu.Item as="li" link styleName="menu-item">
        <Link
          aria-current={isCurrentLink(props, 'calendar')}
          aria-label="calendar"
          to="/rep-visits/calendar"
          styleName="menu-link"
          activeClassName={active}
        >
          <FormattedMessage id="repvisits.menu.calendar" defaultMessage="Calendar" />
        </Link>
      </Menu.Item>
      <Menu.Item as="li" link styleName="menu-item">
        <Link
          aria-current={isCurrentLink(props, 'travel-plan')}
          aria-label="travel plan"
          to="/rep-visits/travel-plan"
          styleName="menu-link"
          activeClassName={active}
        >
          <FormattedMessage id="repvisits.menu.travelPlan" defaultMessage="Travel Plan" />
        </Link>
      </Menu.Item>
      <Menu.Item as="li" link styleName="menu-item">
        <Link
          aria-current={isCurrentLink(props, 'contacts')}
          aria-label="contacts"
          to="/rep-visits/contacts"
          styleName="menu-link"
          activeClassName={active}
        >
          <FormattedMessage id="repvisits.menu.contacts" defaultMessage="Contacts" />
        </Link>
      </Menu.Item>
      <Menu.Item as="li" link styleName="menu-item">
        <Link
          aria-current={isCurrentLink(props, 'recommendations')}
          aria-label="recommendations"
          to="/rep-visits/recommendations"
          styleName="menu-link"
          activeClassName={active}
        >
          <FormattedMessage id="repvisits.menu.recommendations" defaultMessage="Recommendations" />
        </Link>
      </Menu.Item>
      <Menu.Item as="li" link styleName="menu-item">
        <Link
          aria-current={isCurrentLink(props, 'requests')}
          aria-label="notifications"
          to="/rep-visits/notifications/requests"
          styleName="menu-link"
          activeClassName={active}
        >
          <div styleName="menu-item-content">
            <FormattedMessage id="repvisits.menu.notifications" defaultMessage="Notifications" />
            <FeatureEnabled allOf={[REPVISITS_RSVP_COUNTER]}>
              <RepVisitsPendingCounter />
            </FeatureEnabled>
          </div>
        </Link>
      </Menu.Item>
      <Menu.Item as="li" link styleName="menu-item">
        <Link
          aria-current={isCurrentLink(props, 'visit-feedback')}
          aria-label="visit feedback"
          to="/rep-visits/visit-feedback"
          styleName="menu-link"
          activeClassName={active}
        >
          <FormattedMessage id="repvisits.menu.visitFeedback" defaultMessage="Visit Feedback" />
        </Link>
      </Menu.Item>
    </Menu>
  </nav>
);

MenuList.propTypes = {
  className: PropTypes.string,
  currentPathName: PropTypes.string,
};

export default MenuList;
